import { useQuery, gql } from '@apollo/react-hooks';

const GET_ATTACHMENT_TENANT_STORAGE_USAGE = gql`
  query GetAttachmentTenantStorageUsage($tenantId: String!) {
    getAttachmentTenantStorageUsage(tenantId: $tenantId) {
      data {
        totalUsedBytes
      }
      status
      errors
    }
  }
`;

const useAttachmentTenantStorage = (tenantId: string | null | undefined) => {
  const query = useQuery(GET_ATTACHMENT_TENANT_STORAGE_USAGE, {
    variables: { tenantId: tenantId || '' },
    skip: !tenantId,
  });

  const totalUsedBytes: number =
    query?.data?.getAttachmentTenantStorageUsage?.data?.totalUsedBytes ?? 0;

  return { ...query, totalUsedBytes };
};

export default useAttachmentTenantStorage;
